import type React from 'react'
import { createContext, useContext, useState } from 'react'

interface ErrorContextProps {
  error: string | null
  setError: React.Dispatch<React.SetStateAction<string | null>>
}

const ErrorContext = createContext<ErrorContextProps | undefined>(undefined)

export const ErrorProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [error, setError] = useState<string | null>(null)

  return (
    <ErrorContext.Provider value={{ error, setError }}>
      {children}
    </ErrorContext.Provider>
  )
}

export const useError = () => {
  const context = useContext(ErrorContext)
  if (!context) {
    throw new Error('useError must be used within an ErrorProvider')
  }
  return context
}
